import { Controller } from "@hotwired/stimulus"

// Click-to-copy on a read-only URL input. Click anywhere on the field to select
// the text; click the "copy" button to write it to the clipboard.
export default class extends Controller {
  static targets = ["field", "copyIcon", "checkIcon", "status"]

  selectAll() {
    if (this.hasFieldTarget) this.fieldTarget.select()
  }

  async copy() {
    if (!this.hasFieldTarget) return
    const url = this.fieldTarget.value

    try {
      await navigator.clipboard.writeText(url)
    } catch (_err) {
      // Fall back to the old execCommand path for older browsers / non-https
      this.fieldTarget.select()
      try { document.execCommand("copy") } catch (_e) { /* swallow */ }
    }

    this.showCopied()
  }

  showCopied() {
    if (this.hasCopyIconTarget) this.copyIconTarget.classList.add("hidden")
    if (this.hasCheckIconTarget) this.checkIconTarget.classList.remove("hidden")
    if (this.hasStatusTarget) this.statusTarget.textContent = "Copied to clipboard"

    clearTimeout(this._resetTimer)
    this._resetTimer = setTimeout(() => this.reset(), 1800)
  }

  reset() {
    if (this.hasCopyIconTarget) this.copyIconTarget.classList.remove("hidden")
    if (this.hasCheckIconTarget) this.checkIconTarget.classList.add("hidden")
    if (this.hasStatusTarget) this.statusTarget.textContent = ""
  }
}
